
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components"
import { GoogleMap, useLoadScript, Marker, DirectionsRenderer, DirectionsService } from "@react-google-maps/api"
import IsletmeDetails from "./IsletmeDetails";

const Container = styled.div`

    width: calc(100% - 420px);
    height: 100vh;
    position: relative;

    .map{
      width: 100%;
      height: 100%;
      position: relative;

      .yellow-pages-menu{
        position: absolute;
        top: 15px;
        left: 15px;
        display: flex;
        gap: 10px;

        .active-menu-item{
          color: var(--color-main) !important;
          border: 2px solid var(--color-main) !important;
        }

        .menu-item{
          width: auto;
          padding: 10px 20px;
          background-color: #fff;
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          border-radius: 5px;
          border: 2px solid transparent;
          cursor: pointer;
          text-align: center;
        }
      }
    }

    @media (max-width: 1450px) {
      width: calc(100% - 350px);
  }

  @media (max-width: 1100px) {
    border: none;
    width: 100%;
}

@media (max-width: 700px) {

  .yellow-pages-menu{
    display: none !important;
  }

}


`



const YellowPagesMapSide = ({activePoint, isletmeList, menuList, activeMenu, setActiveMenu}) => {

    const [map, setMap] = useState(null);

    const center = useMemo(() => ({lat: 38.75, lng: 33.75 }),[])

    const [pointList, setPointList] = useState([])

    const onLoad = (mapInstance) => {
        setMap(mapInstance);
      };

      useEffect(() => {
        const list = isletmeList?.map((item) => {
          return {
            lat: item.location.latitude,
            lng: item.location.longitude
          }
        })
        setPointList(list)
      },[isletmeList])


      const markerOptions = {
        icon: {
          scaledSize: new window.google.maps.Size(28, 42),
        },
        animation: null
      };
    
      const activeMarkerOptions = {
        icon: {
          scaledSize: new window.google.maps.Size(28, 42),
        },
            animation: window.google.maps.Animation.BOUNCE,
            animationDuration: 3000, // Animasyon süresi (ms)
            animationDelay: 1000, // Animasyon gecikmesi (ms)
      };
    
      

  return (
    <Container>
        <GoogleMap zoom={7} center={center} mapContainerClassName='map' onLoad={onLoad} options={{mapTypeControl: false}}>
          <div className="yellow-pages-menu">
            {
              menuList?.map((item) => {
                return <div onClick={() => setActiveMenu(item)} className={activeMenu?.id === item?.id ? "menu-item active-menu-item" : "menu-item"}>{item.text}</div>
              })
            }
          </div>
        {
            pointList?.map((item, i) => (
              <Marker options={activePoint?.lat === item.lat ? activeMarkerOptions : markerOptions} key={i} position={{lat: item.lat, lng:item.lng }} onClick={()=> {}} />  
            ))
          } 
        </GoogleMap>

        {/* <IsletmeDetails/> */}
    </Container>
  )
}

export default YellowPagesMapSide